export default {
    offset: {
        top: 30,
        right: 30,
        bottom: 30,
        left: 30,
    },
    label: {
        enabled: true,
        styles: {
            fontSize: 14,
            color: '#fff',
        },
    },
    value: {
        enabled: true,
        styles: {
            fontSize: 14,
            color: '#fff',
        },
    },
    area: {
        gradient: false,
        smooth: true
    },
    hover: {
        enabled: true,
        value: 15
    }
};
